module.exports = __webpack_public_path__ + "static/media/cyberessentials_certification_vector.a69a1736.png";